module.exports = __webpack_public_path__ + "img/minimize.ebc7b1a7.svg";